import React, { useEffect, useState } from "react";
import { Table, Button, Select, Input, Tag, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FaEye } from "react-icons/fa";
import { getStates } from "../features/statecity/statecitySlice";
import { getUsers } from "../features/cutomers/customerSlice";
import { getBrands } from "../features/brand/brandSlice";
import {
  getPlacementList,
  resetState,
} from "../features/placements/placementSlice";
// import { formatDate, calculateAge } from "../utils/dateHelper";
import { ExportOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";

// const { Search } = Input;

const columns = [
  {
    dataIndex: "key",
    title: "Sr No",
    width: 4,
  },
  {
    dataIndex: "state",
    title: "State",
    width: 10,
  },
  {
    dataIndex: "classes",
    title: "Class",
    width: 10,
  },
  {
    dataIndex: "roll_no",
    title: "Roll No.",
    width: 10,
  },
  {
    dataIndex: "student_name",
    title: "Student Name",
    width: 20,
  },
  {
    dataIndex: "student_dob",
    title: "Age",
    width: 20,
  },
  {
    dataIndex: "job_role",
    title: "Job Role",
    width: 20,
  },
  {
    dataIndex: "company",
    title: "Decision",
    width: 40,
  },
  {
    dataIndex: "placed_by",
    title: "Marked By",
    width: 50,
  },
];

const Placementreport = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [vcData, setvcData] = useState([]);
  const [vtData, setvtData] = useState([]);
  const [selectedVC, setselectedVC] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [filteredStatus, setFilteredStatus] = useState("");
  const [selectedVT, setSelectedVT] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [totalStudents, setTotalStudents] = useState(0);
  const statelistState = useSelector((state) => state.statecity.statelist);
  const vclistState = useSelector((state) => state.customer.customers);
  const classlistState = useSelector((state) => state.brand.brands);
  const placementlist = useSelector(
    (state) => state.placementList.placementLists || []
  );

  useEffect(() => {
    dispatch(resetState());
    dispatch(getPlacementList());
    dispatch(getStates());
    dispatch(getUsers());
    dispatch(getBrands());
  }, [dispatch]);

  useEffect(() => {
    if (placementlist.length > 0) {
      setTotalStudents(placementlist.length);
      setFilteredData(placementlist);
    }
  }, [placementlist]);

  const handleVcChange = (value) => {
    const vtfilterData = vclistState.filter(
      (customer) => customer.vcuser_id === value
    );
    setvtData(vtfilterData);
    setselectedVC(value);
  };

  const handleStateChange = (value) => {
    const vcfilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setvcData(vcfilterData);
    setSelectedState(value);
  };

  const handleVTChange = (value) => {
    setSelectedVT(value);
  };

  const handleClassChange = (value) => {
    setSelectedClass(value);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleViewSearch = () => {
    const filteredData = placementlist.filter((Placement) => {
      const matchesState = selectedState
        ? Placement.studentDetails.State === selectedState
        : true;
      const matchesVT = selectedVT
        ? Placement.userDetails._id === selectedVT
        : true;
      const matchesClass = selectedClass
        ? Placement.class === selectedClass
        : true;
      const matchesStatus = filteredStatus
        ? filteredStatus === "above18"
          ? calculateAge(Placement.studentDetails.Dob) >= 18
          : filteredStatus === "below18"
          ? calculateAge(Placement.studentDetails.Dob) < 18
          : Placement.company_placedin === filteredStatus
        : true;

      return matchesState && matchesVT && matchesClass && matchesStatus;
    });

    setFilteredData(Array.isArray(filteredData) ? filteredData : []);
  };

  const handleStatusClick = (status) => {
    setFilteredStatus(status);
    handleViewSearch();
  };

  const handleClear = () => {
    form.resetFields();
    setSelectedState("");
    setselectedVC("");
    setSelectedVT("");
    setSelectedClass("");
    setFilteredStatus("");
    setFilteredData(placementlist);
    setvcData([]);
    setvtData([]);
  };

  const summary = Array.isArray(filteredData)
    ? filteredData.reduce(
        (acc, curr) => {
          if (curr.company_placedin === "Job") acc.job += 1;
          else if (curr.company_placedin === "Further studies")
            acc.furtherstudies += 1;

          const age = calculateAge(curr?.studentDetails?.Dob);
          if (age >= 18) acc.above18 += 1;
          else acc.below18 += 1;

          return acc;
        },
        { job: 0, furtherstudies: 0, above18: 0, below18: 0 }
      )
    : { job: 0, furtherstudies: 0, above18: 0, below18: 0 };

  const filteredDatas = Array.isArray(filteredData)
    ? filteredData.filter((Placement) => {
        return (
          Placement.student_name.toLowerCase().includes(searchQuery) ||
          Placement.job_role.toLowerCase().includes(searchQuery) ||
          Placement.company_placedin.toLowerCase().includes(searchQuery) ||
          Placement.location.toLowerCase().includes(searchQuery) ||
          Placement.userDetails.name.toLowerCase().includes(searchQuery)
        );
      })
    : [];

  const data1 = filteredDatas.map((Placement, index) => {
    return {
      key: index + 1,
      state: Placement?.studentDetails?.State,
      classes: Placement?.class,
      roll_no: Placement?.studentDetails?.Roll_Number,
      student_name: Placement?.student_name,
      student_dob: calculateAge(Placement?.studentDetails?.Dob) + " Year",
      job_role: Placement?.job_role,
      company: Placement?.company_placedin || "N/A",
      placed_by: Placement?.userDetails?.name,
    };
  });

  const csvHeaders = [
    { label: "Sr. No", key: "key" },
    { label: "State", key: "state" },
    { label: "Class", key: "classes" },
    { label: "Roll Number", key: "roll_no" },
    { label: "Student Name", key: "student_name" },
    { label: "Age", key: "student_dob" },
    { label: "Job Role", key: "job_role" },
    { label: "Company", key: "company" },
    { label: "Marked By", key: "placed_by" },
  ];

  return (
    <div>
      <h3 className="mb-4 title">Placement Reports</h3>
      <div
        style={{
          marginBottom: 16,
          backgroundColor: "#ffffff",
          border: "1px solid #eef2f6",
          padding: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
        }}
      >
        <div style={{ display: "flex", gap: "16px" }}>
          <Form form={form} layout="inline" onFinish={handleViewSearch}>
            <Form.Item
              name="state_name"
              rules={[
                {
                  required: true,
                  message: "Please Select State!",
                },
              ]}
            >
              <Select
                style={{ width: 160 }}
                placeholder="Select State"
                onChange={handleStateChange}
              >
                <Select.Option key="default" value="">
                  Select State
                </Select.Option>
                {statelistState.map((i, j) => (
                  <Select.Option key={j} value={i.code}>
                    {i.state_name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="state_vc">
              <Select
                style={{ width: 160 }}
                placeholder="Select VC"
                onChange={handleVcChange}
              >
                <Select.Option key="default" value="">
                  Select VC
                </Select.Option>
                {vcData
                  .filter((item) => item.role === "vc")
                  .map((item) => (
                    <Select.Option key={item._id} value={item._id}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item name="state_vt">
              <Select
                style={{ width: 160 }}
                placeholder="Select VT"
                onChange={handleVTChange}
              >
                <Select.Option key="default" value="">
                  Select VT
                </Select.Option>
                {vtData
                  .filter((item) => item.role === "vt")
                  .map((item) => (
                    <Select.Option key={item._id} value={item._id}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item name="state_class">
              <Select
                style={{ width: 160 }}
                placeholder="Select Class"
                onChange={handleClassChange}
              >
                <Select.Option key="default" value="">
                  Select Class
                </Select.Option>
                {classlistState.map((cls, index) => (
                  <Select.Option key={index} value={cls.title}>
                    {cls.title}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item>
              <Button
                style={{ marginRight: 20, backgroundColor: "#a7b54d" }}
                type="primary"
                htmlType="submit"
              >
                <FaEye /> &nbsp; Search
              </Button>
            </Form.Item>

            <Form.Item>
              <Button type="default" onClick={handleClear}>
                Clear
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      <div
        style={{
          color: "white",
          marginBottom: 1,
          display: "flex",
          justifyContent: "flex-end",
          flexGrow: 1,
        }}
      >
        <div style={{ display: "flex", gap: "20px" }}>
          <div
            onClick={() => handleStatusClick("Job")}
            style={{ cursor: "pointer" }}
          >
            <Tag color="green">Willing Job: {summary.job}</Tag>
          </div>

          <div
            onClick={() => handleStatusClick("Further studies")}
            style={{ cursor: "pointer" }}
          >
            <Tag color="red">Further Studies: {summary.furtherstudies}</Tag>
          </div>
          <div
            onClick={() => handleStatusClick("above18")}
            style={{ cursor: "pointer" }}
          >
            <Tag color="yellow">Above 18: {summary.above18}</Tag>
          </div>
          <div
            onClick={() => handleStatusClick("below18")}
            style={{ cursor: "pointer" }}
          >
            <Tag color="blue">Below 18: {summary.below18}</Tag>
          </div>

          <div onClick={handleClear} style={{ cursor: "pointer" }}>
            <Tag color="blue">Total Students: {totalStudents}</Tag>
          </div>
        </div>
      </div>

      <CSVLink
        data={data1}
        headers={csvHeaders}
        filename={`Placement-Report${new Date().toISOString()}.csv`}
      >
        <Button
          type="primary"
          className="exportcsv"
          style={{ marginBottom: 5 }}
        >
          <ExportOutlined /> Export to CSV
        </Button>
      </CSVLink>

      <Table
        style={{ marginBottom: 16, padding: "20px" }}
        className="custom-table"
        columns={columns}
        dataSource={data1}
        //pagination={{ pageSize: 20 }}
        size="small"
      />
    </div>
  );
};

export default Placementreport;
